import React from "react";
import { useSelector } from "react-redux";
import { format, parseISO } from "date-fns";
import { Link, useNavigate } from "react-router-dom";

export function DocumentsTab({ watch, setValue }) {
  let session = useSelector((state) => state.session);
  let navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-3 p-3 bg-white"}>
      {(watch("documents") || []).length === 0 && (
        <div>No documents linked</div>
      )}
      {(watch("documents") || [])
        .sort(
          (a, b) =>
            parseISO(b.date || new Date().toISOString()) -
            parseISO(a.date || new Date().toISOString())
        )
        .map((document) => {
          let { reference, amount, currency, date } = document;
          return (
            <Link
              to={`/documents/${document.id}`}
              className={
                "p-2 bg-blue-50 hover:bg-blue-100 cursor-pointer rounded flex gap-3 px-5"
              }
            >
              <div style={{ width: 150 }}>
                {date
                  ? format(parseISO(date), session.account.dateFormat)
                  : "No date"}
              </div>
              <div style={{ width: 200 }}>
                {amount ? (
                  <>
                    {amount} {currency}
                  </>
                ) : (
                  <>No amount</>
                )}
              </div>
              <div
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {reference}
              </div>
            </Link>
          );
        })}
    </div>
  );
}
